








































































































import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BackToMyPageTopButton from '@spa/components/organisms/mypage/BackToMypPageTopButton.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import UserService from '@spa/services/api/user'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    SpaErrorDialog,
    BackToMyPageTopButton,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ChangePassword extends Mixins<PluginMixin>(PluginMixin) {
  status: Status = Status.Pending

  messsage: string = ''

  password: string = ''

  newPassword: string = ''

  newPasswordConfirm: string = ''

  isUnauthorized: boolean = false

  hasErrorOnSamePassword: boolean = false

  showModal: boolean = false

  modalMessage: string = ''

  readonly STATUS_CODE_UNAUTHORIZED: number = 401

  userService = new UserService()

  get user(): User {
    return this.$store.state.user.user
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get isFailed(): boolean {
    return this.status === Status.Failed
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  async validateForm(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }

    if (this.isSameCurrentPassword()) {
      this.hasErrorOnSamePassword = true

      return
    }

    this.hasErrorOnSamePassword = false
    this.status = Status.Loading

    const result = await this.userService.changePassword(this.password, this.newPassword)

    if (result.isLeft()) {

      // @ts-ignore
      const statusCode = result.value.response.statusCode

      if (statusCode === this.STATUS_CODE_UNAUTHORIZED) {
        this.isUnauthorized = true
        this.status = Status.Failed
      }

      this.modalMessage = `
        <p>
          パスワードを変更できませんでした。<br/>
          ※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。
        </p>
      `
      this.showModal = true

      this.status = Status.Failed

      // TODO: Show detailed reason?

      return
    }

    this.status = Status.Completed

  }

  private  isSameCurrentPassword() {
    return this.password === this.newPassword
  }

}
